// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./_fonts.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  --app-bgc: #101010;
  --app-color: #fff;

  --font-family-main: 'Inter', 'Arial', sans-serif;
  --font-weight-500: 500;
  --font-weight-600: 600;

  --font-size-s: 12px;
  --font-line-s: 14px;
  --font-s: var(--font-size-s) / var(--font-line-s) var(--font-family-main);
  --font-s-500: var(--font-weight-500) --font-s;
  --font-s-600: var(--font-weight-600) --font-s;

  --font-size-m: 14px;
  --font-line-m: 17px;
  --font-m: var(--font-size-m) / var(--font-line-m) var(--font-family-main);
  --font-m-bold: var(--font-weight-600) var(--font-m);
  --font-m-500: var(--font-weight-500) var(--font-m);

  --font-size-16: 16px;
  --font-line-16: 25px;
  --font-16: var(--font-size-16) / var(--font-line-16) var(--font-family-main);
  --font-16-500: var(--font-weight-500) var(--font-16);
  --font-16-bold: var(--font-weight-600) var(--font-16);

  --font-size-18: 18px;
  --font-line-18: 21px;
  --font-18: var(--font-size-18) / var(--font-line-18) var(--font-family-main);
  --font-18-bold: var(--font-weight-600) var(--font-18);
  --font-18-500: var(--font-weight-500) var(--font-18);

  --font-size-l: 20px;
  --font-line-l: 28px;
  --font-l: var(--font-size-l) / var(--font-line-l) var(--font-family-main);
  --font-l-500: var(--font-weight-500) var(--font-l);
  --font-l-bold: var(--font-weight-600) var(--font-l);

  --font-size-30: 30px;
  --font-line-38: 38px;
  --font-30: var(--font-size-30) / var(--font-line-38) var(--font-family-main);
  --font-30-bold: var(--font-weight-600) var(--font-30);

  --font-size-32: 32px;
  --font-line-36: 36px;
  --font-32: var(--font-size-32) / var(--font-line-36) var(--font-family-main);
  --font-32-500: var(--font-weight-500) var(--font-32);
  --font-32-bold: var(--font-weight-600) var(--font-32);

  --font-size-34: 34px;
  --font-34: var(--font-size-30) / normal var(--font-family-main);
  --font-34-500: var(--font-weight-600) var(--font-34);

  --font-size-38: 38px;
  --font-line-44: 44px;
  --font-38: var(--font-size-38) / var(--font-line-44) var(--font-family-main);
  --font-38-500: var(--font-weight-500) var(--font-38);
  --font-38-600: var(--font-weight-600) var(--font-38);

  --font-size-46: 46px;
  --font-line-46: 46px;
  --font-46: var(--font-size-46) / var(--font-line-46) var(--font-family-main);
  --font-46-500: var(--font-weight-500) var(--font-46);
  --font-46-600: var(--font-weight-600) var(--font-46);

  --font-size-62: 62px;
  --font-line-52: 52px;
  --font-62: var(--font-size-62) / var(--font-line-52) var(--font-family-main);
  --font-62-500: var(--font-weight-500) var(--font-62);
  --font-62-600: var(--font-weight-600) var(--font-62);
}

.rootWrapper {
  width: 1080px;
  height: 1920px;
  overflow: hidden;
  position: relative;
  color: var(--app-color);
  background-color: var(--app-bgc);
  font: var(--font-m);
}

.ww_source {
  display: none !important;
}

.ww_cond {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,gDAAgD;EAChD,sBAAsB;EACtB,sBAAsB;;EAEtB,mBAAmB;EACnB,mBAAmB;EACnB,yEAAyE;EACzE,6CAA6C;EAC7C,6CAA6C;;EAE7C,mBAAmB;EACnB,mBAAmB;EACnB,yEAAyE;EACzE,mDAAmD;EACnD,kDAAkD;;EAElD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,oDAAoD;EACpD,qDAAqD;;EAErD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,qDAAqD;EACrD,oDAAoD;;EAEpD,mBAAmB;EACnB,mBAAmB;EACnB,yEAAyE;EACzE,kDAAkD;EAClD,mDAAmD;;EAEnD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,qDAAqD;;EAErD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,oDAAoD;EACpD,qDAAqD;;EAErD,oBAAoB;EACpB,+DAA+D;EAC/D,oDAAoD;;EAEpD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,oDAAoD;EACpD,oDAAoD;;EAEpD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,oDAAoD;EACpD,oDAAoD;;EAEpD,oBAAoB;EACpB,oBAAoB;EACpB,4EAA4E;EAC5E,oDAAoD;EACpD,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["@import '_fonts.scss';\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  --app-bgc: #101010;\n  --app-color: #fff;\n\n  --font-family-main: 'Inter', 'Arial', sans-serif;\n  --font-weight-500: 500;\n  --font-weight-600: 600;\n\n  --font-size-s: 12px;\n  --font-line-s: 14px;\n  --font-s: var(--font-size-s) / var(--font-line-s) var(--font-family-main);\n  --font-s-500: var(--font-weight-500) --font-s;\n  --font-s-600: var(--font-weight-600) --font-s;\n\n  --font-size-m: 14px;\n  --font-line-m: 17px;\n  --font-m: var(--font-size-m) / var(--font-line-m) var(--font-family-main);\n  --font-m-bold: var(--font-weight-600) var(--font-m);\n  --font-m-500: var(--font-weight-500) var(--font-m);\n\n  --font-size-16: 16px;\n  --font-line-16: 25px;\n  --font-16: var(--font-size-16) / var(--font-line-16) var(--font-family-main);\n  --font-16-500: var(--font-weight-500) var(--font-16);\n  --font-16-bold: var(--font-weight-600) var(--font-16);\n\n  --font-size-18: 18px;\n  --font-line-18: 21px;\n  --font-18: var(--font-size-18) / var(--font-line-18) var(--font-family-main);\n  --font-18-bold: var(--font-weight-600) var(--font-18);\n  --font-18-500: var(--font-weight-500) var(--font-18);\n\n  --font-size-l: 20px;\n  --font-line-l: 28px;\n  --font-l: var(--font-size-l) / var(--font-line-l) var(--font-family-main);\n  --font-l-500: var(--font-weight-500) var(--font-l);\n  --font-l-bold: var(--font-weight-600) var(--font-l);\n\n  --font-size-30: 30px;\n  --font-line-38: 38px;\n  --font-30: var(--font-size-30) / var(--font-line-38) var(--font-family-main);\n  --font-30-bold: var(--font-weight-600) var(--font-30);\n\n  --font-size-32: 32px;\n  --font-line-36: 36px;\n  --font-32: var(--font-size-32) / var(--font-line-36) var(--font-family-main);\n  --font-32-500: var(--font-weight-500) var(--font-32);\n  --font-32-bold: var(--font-weight-600) var(--font-32);\n\n  --font-size-34: 34px;\n  --font-34: var(--font-size-30) / normal var(--font-family-main);\n  --font-34-500: var(--font-weight-600) var(--font-34);\n\n  --font-size-38: 38px;\n  --font-line-44: 44px;\n  --font-38: var(--font-size-38) / var(--font-line-44) var(--font-family-main);\n  --font-38-500: var(--font-weight-500) var(--font-38);\n  --font-38-600: var(--font-weight-600) var(--font-38);\n\n  --font-size-46: 46px;\n  --font-line-46: 46px;\n  --font-46: var(--font-size-46) / var(--font-line-46) var(--font-family-main);\n  --font-46-500: var(--font-weight-500) var(--font-46);\n  --font-46-600: var(--font-weight-600) var(--font-46);\n\n  --font-size-62: 62px;\n  --font-line-52: 52px;\n  --font-62: var(--font-size-62) / var(--font-line-52) var(--font-family-main);\n  --font-62-500: var(--font-weight-500) var(--font-62);\n  --font-62-600: var(--font-weight-600) var(--font-62);\n}\n\n.rootWrapper {\n  width: 1080px;\n  height: 1920px;\n  overflow: hidden;\n  position: relative;\n  color: var(--app-color);\n  background-color: var(--app-bgc);\n  font: var(--font-m);\n}\n\n.ww_source {\n  display: none !important;\n}\n\n.ww_cond {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
